<template>
    <CCol v-bind="$attrs">
        <ValidationProvider
            tag="div"
            :vid="vid"
            :name="name"
            :rules="rules"
            v-slot="{ errors, validate }"
        >
            <label v-if="!innerLabel && !hideLabel" class="d-block mb-0">{{ name }}<span v-if="required" class="text-danger">*</span>
            </label>
            <CImageInputFile :inpClass="inpClass" @change="onChangeSrc($event, validate)" :disabled="disabled">
                 <template #card-body-wrapper>
                    <slot name="icon-wrapper" v-bind:errors="errors"></slot>
                </template>
                <template #card-body>
                    <slot name="icon" :v-bind:errors="errors">
                        <span v-if="innerLabel" class="font-xs d-block">{{ name }}</span>
                        <FaIcon icon="cloud-arrow-up" class="fa-2x" />
                    </slot>
                </template>
                <template #invalid-feedback>
                    <slot name="invalid">
                        <span class="text-center invalid-feedback d-block">{{ errors[0] }}</span>
                    </slot>
                </template>
                <template #after-card-body>
                    <CProgress v-show="showProgress" :value="image.uploadPercent" height="3px" />
                </template>
            </CImageInputFile>
            <slot name="after-box"></slot>
        </ValidationProvider>
        <div v-if="imgUrl && showImagePreview" class="position-relative">
            <CCustomImage
                :is-secret="image.disk == 'secret' || imgUrl.includes('secrets')"
                :src="imgUrl"
                customClass="w-50 my-2 mx-auto d-block"
                :key="imgUrl"
                :scaler="scaler"
            />
        </div>
    </CCol>
</template>


<script>
import { uploadService } from '@/services/api'
import CImageInputFile from './CImageInputFile'
import { getFirstOfArray } from '@/common/arrays'
import { DefaultInputFileProps } from './defaultProps'
import CCustomImage from './../CCustomImage'

export default {
    name: 'CCustomImageInputFile',

    components: {
        CImageInputFile,
        CCustomImage,
    },

    props: {
        ...DefaultInputFileProps,
        path: {
            required: true
        },
        innerLabel: {
            type: Boolean,
            default: false
        },
        showImagePreview: {
            type: Boolean,
            default: false,
        },
        hideLabel: {
            type: Boolean,
            default: false,
        },
        showProgress: {
            type: Boolean,
            default: true
        },
        inpClass: {
            type: [String, Object, Array],
            default: ''
        },
        scaler: {
            default: false,
            type: Boolean,
        }
    },

    data() {
        return {
            image: {
                uploadPercent: 0,
                url: '',
                disk: ''
            },
        }
    },

    computed: {
        imgUrl: {
            get() {
                return this.value || this.image.url
            },
            set(val) {
                this.image.url = val
            }
        }
    },

    methods: {
        onChangeSrc(event, validate) {
            this.image.uploadPercent = 0

            validate(event).then((result) => {
                if (!result.valid) {
                    return
                }

                const data = {
                    file: getFirstOfArray(event.target.files)
                }

                if (!data.file) {
                    return
                }

                uploadService.doUpload(data, this.path, (percent) => {
                    this.image.uploadPercent = percent
                }).then((response) => {
                    this.imgUrl = response.data.data.url
                    this.image.disk = response.data.data.disk

                    this.$emit('input', this.image.url)
                })
            })
        },
    }
}
</script>